import { render } from "./NoahHakkinda.vue?vue&type=template&id=2eafcf0d&scoped=true"
import script from "./NoahHakkinda.vue?vue&type=script&lang=js"
export * from "./NoahHakkinda.vue?vue&type=script&lang=js"

import "./NoahHakkinda.vue?vue&type=style&index=0&id=2eafcf0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eafcf0d"]])

export default __exports__